import { render } from "./evaluation.vue?vue&type=template&id=4c24ced3&ts=true"
import script from "./evaluation.vue?vue&type=script&lang=ts"
export * from "./evaluation.vue?vue&type=script&lang=ts"

import "./evaluation.vue?vue&type=style&index=0&id=4c24ced3&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__